/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { authMethodShapeSchema } from './authMethodShapeSchema';
import { oAuthProviderConfigSchema } from './oAuthProviderConfigSchema';

export const oAuth2AuthCodeSchema = z
  .lazy(() => authMethodShapeSchema)
  .and(
    z.object({
      get oauthConfig() {
        return oAuthProviderConfigSchema;
      },
    }),
  );
